<template>
	<v-container fluid>
			<v-row align="center">
			<v-progress-circular indeterminate v-if="loading" class="my-orange mx-auto"></v-progress-circular>
		</v-row>

		<v-row justify="center" align="center"
			style="position: sticky;  top: 0px; background-color: rgb(255, 255, 255); z-index: 5; box-shadow: 0px 4px 7px -4px rgba(0, 0, 0, 0.5);">
			<v-col cols="1">
				<v-btn text @click="$router.go(-1)">
					<v-icon>mdi-chevron-left</v-icon>Voltar
				</v-btn>
			</v-col>
			<v-col cols="12" md="11" class="align-center justify-center d-flex" style="gap: 1rem">
				<v-text-field hide-details="true" v-model="buscaModel" style="max-width: 450px" outlined color="#f15a24"
					label="Faça uma busca por algum termo específico"></v-text-field>
				<v-btn class="" style="
						background-color: #f15a24;
						color: #ffffff;
						text-transform: none;
					" @click="buscarLei">
					Buscar
					<v-icon> mdi-magnify </v-icon>
				</v-btn>
			</v-col>
			<!-- <v-col cols="12" md="2">
				<v-btn @click="addToVadeMecum">
                      Adicionar a Vade Mecum
                    </v-btn>
			</v-col> -->
		</v-row>
		<v-row>

			<v-col cols="12" md="6" class="d-flex align-center">
				<h2 class="my-orange gt-bold mb-0">{{ lei.numero_lei }}</h2>
			</v-col>

			<!-- <v-col cols="12" md="6">
				<v-row>
					<v-col>
						<v-img v-if="lei.imagem_lei != ''" :src="lei.imagem_lei" height="250"></v-img>
						<v-img contain src="../assets/semimagem.png" height="250"></v-img>
					</v-col>
				</v-row>
			</v-col> -->

			<v-col cols="12" md="12">
				<p class="font-weight-light">{{ lei.nome_lei }}</p>
			</v-col>

		</v-row>
		<v-row>
			<v-col>
				<DynamicScroller id="conteudos" ref="conteudos" class="scroller" :items="conteudos" key-field="id_reg" :min-item-size="54">
					<!-- <v-virtual-scroll ref="conteudos" :items="conteudos" :height="`500px`" :itemHeight="210"> -->
					<template v-slot:default="{ item, index, active }">
						<DynamicScrollerItem :item="item" :data-index="index" :active="active" :size-dependencies="[
							item.conteudo, item.anotacoes
						]">
								<v-col class="rowAnnotation"  cols="12">
									<p v-html="item.conteudo" :id="item.id_reg"></p>
									<v-list v-if="item.anotacoes" style="background-color: transparent;">
										<v-list-item class="flex-column d-flex justify-center pa-3"
											v-for="(a, a_index) in item.anotacoes" :key="a.id" :id="a.id">
											<v-card width="100%" elevation="1">
													<v-card-title class="annotation d-flex flex-row align-center justify-space-between">
														<p class="d-flex align-center mb-0">
															<img width="30px" class="rounded-circle mr-1"
																:src="a.user_created.avatar ? `https://api.mylegis.com.br/assets/${a.user_created.avatar}` : require('../assets/icon-person.svg')" />
															{{ a.user_created.first_name }} em
															{{ a.date_created | brdatetime }}
														</p>
														<p class="d-flex justify-end mb-0">
															<v-btn @click="editAnnotation(item, a)" text>
																<v-icon>mdi-pencil</v-icon></v-btn>
															<v-btn
																@click="confirm = true; delAnnotation = { aId: a.id, cIndex: index, aIndex: a_index }"
																text><v-icon>mdi-delete</v-icon></v-btn>
														</p>
													</v-card-title>
												<v-card-text>
													<p class="d-flex flex-column annotation" v-html="a.texto"></p>
													<small class="pr-4">
														<span v-if="a.status === `group`">
															<v-icon>mdi-account-group</v-icon>
															{{ a.id_grupo.nome_grupo }}
														</span>
														<span v-else>
															<v-icon small>{{
																a.status === `private`
																? `mdi-lock`
																: `mdi-earth`
															}}</v-icon>
															{{ a.status | filterStatus }}
														</span>
														-
														<v-icon small>mdi-clock-outline</v-icon>
														{{ a.date_updated === null ? "Criado em" : "Atualizado em" }}
														{{ a.date_updated === null ? a.date_created : a.date_updated |
															brdatetime }}
													</small>
												</v-card-text>
											</v-card>
										</v-list-item>
									</v-list>
									<div>
										<p class="d-flex justify-end">
											<v-btn :disabled="user.plano === `plano-free`" class="mt-5" @click="newAnnotation(item)" text
												style="color: #f15a24">Nova
												Anotação
												<v-icon>mdi-plus</v-icon></v-btn>
										</p>
									</div>
								</v-col>
						</DynamicScrollerItem>
					</template>
				</DynamicScroller>
				<!-- </v-virtual-scroll> -->
			</v-col>
		</v-row>

		<v-row>
			<v-col>
				<label class="tag-sm mx-1" v-for="(t, i) in lei.tags" :key="i">
					<input type="checkbox" disabled class="tag-sm-checkbox" />
					<span class="tag-sm-container">
						<span class="tag-sm-content">
							<span>{{ t }}</span>
							<span class="tag-sm-icon"></span>
						</span>
					</span>
				</label>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<p class="font-weight-light">
					Fonte:
					<span class="my-orange"> {{ lei.esfera_lei }}</span>
				</p>
			</v-col>
		</v-row>
		<v-divider class="my-5 mb-7" color="#f57029"></v-divider>
		<!-- <v-row>
			<v-col>
				<h3 class="my-orange gt-bold mb-2 d-flex- align-center">
					<img width="30px" class="mr-3" src="../assets/icon-talkbubble.svg" />
					{{
						comentarios.length > 0
						? comentarios.length +
						" Comentário" + (comentarios.length > 1 ? "s" : "")
						: "Nenhum comentário público"
					}}
				</h3>
			</v-col>
		</v-row>

		<v-row class="mx-1 mb-3">
			<v-col v-for="p in comentarios" :key="p.id" cols="12"
				class="pa-10 d-flex flex-row align-left justify-start grey lighten-3"
				:class="intBreakPoint <= 0 ? 'flex-column' : 'flex-row'">
				<avatar-dpo :user="p.user_created"> </avatar-dpo>

				<p class="text-left font-weight-light">
					<span>
						<h3 class="my-orange gt-bold mb-0">
							{{
								p.user_created.first_name +
								" " +
								p.user_created.last_name !== null ? p.user_created.last_name : ``
							}}
						</h3>
					</span>
					<span>{{ p.date_created | brdatetime }}</span><br />
					<span class="comentario" v-html="p.mensagem"></span>
				</p>
			</v-col>
		</v-row>
		<v-row class="mx-0">
			<v-col cols="12" class="pt-5 px-0 d-flex flex-column align-end">
				<h4 class="text-left mb-n1 my-orange gt-bold" style="width: 100%">
					Novo Comentário
				</h4>
				<div style="width: 100%; margin: 10px 0px">
					<VueEditor ref="editor1" color="#F15A24" :editor-toolbar="customToolbar1"
						@image-added="handleImageAdded" use-custom-image-handler v-model="comentario" />
				</div>
				<v-btn class="float-right" dark color="#F15A24" @click="enviarComentario">
					Enviar
				</v-btn>
			</v-col>
		</v-row> -->
		<v-dialog width="700px" v-model="showNewAnnotation">
			<v-card class="px-5">
				<v-card-title class="px-0">Nova Anotação <v-spacer />
					<v-btn @click="showNewAnnotation = false" text><v-icon large>mdi-close</v-icon></v-btn></v-card-title>
				<v-card-text>
					<h3></h3>
					<p class="pa-2" style="border: 1px dashed #f15a24" v-html="conteudoSelected.conteudo"></p>
					<h3>Visibilidade</h3>
					<v-select color="#F15A24" :items="statusAnnotation" v-model="annotation.status"></v-select>
					<h3 v-if="annotation.status == `group`">Selecione o grupo</h3>
					<v-select v-if="annotation.status == `group`" item-text="grupos_id.nome_grupo" item-value="grupos_id.id"
						color="#F15A24" :items="groups" v-model="annotation.id_grupo"></v-select>
					<h3 class="d-flex">
						Conteúdo
						<v-spacer></v-spacer>
						<v-btn text small @click="undo"><v-icon>mdi-undo</v-icon> Desfazer</v-btn>
						<v-btn @click="redo" text small><v-icon>mdi-redo</v-icon> Refazer</v-btn>
						<v-file-input v-model="files" style="height:20px; margin-top:-20px;" placeholder="Adicionar Arquivo"
							flat :prepend-icon="'mdi-plus'" @change="newFile" color="#F15A24">
						</v-file-input>
					</h3>
					<VueEditor use-custom-image-handler @image-added="handleImageAdded" ref="editor" color="#F15A24"
						:editor-toolbar="customToolbar" v-model="annotation.texto" />
				</v-card-text>
				<v-card-actions class="justify-end px-0">
					<v-btn text @click="showNewAnnotation = false">Cancelar</v-btn>
					<v-btn :loading="loadingNewAnnotation" dark @click="saveNewAnnotation()" color="#F15A24">Salvar
						<v-icon class="ml-1" small>mdi-content-save</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog width="700px" v-model="showBusca">
			<v-card class="px-5">
				<v-card-title class="px-0">Busca interna - {{ buscaModel }} <v-spacer />
					<v-btn @click="showBusca = false" text><v-icon large>mdi-close</v-icon></v-btn></v-card-title>
				<v-card-text>
					<p v-for="l in resultadoBusca" :key="l.id_reg">
						{{ l.conteudo }} <v-btn @click="gotoRef(l.id_reg)" text color="#f15a24">Ir até <v-icon
								color="#f15a24" small>mdi-arrow-down-right</v-icon></v-btn>
					</p>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="confirm" width="25vw">
			<v-card>
				<v-card-title>
					Remover Anotação
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" md="12">
							<h2 style="gap: 1rem; color: #F15A24">
								<v-icon>mdi-account-trash</v-icon>Você tem certeza que deseja remover está anotação ?<br />
								<small class="black--text text-caption">Obs: Está ação é irreversível. </small>
							</h2>
						</v-col>
					</v-row>

				</v-card-text>
				<v-card-actions class="justify-end">
					<v-btn text @click="confirm = false"> Cancelar </v-btn>

					<v-btn color="#F15A24" :loading="loadingDelete" @click="deleteAnnotation()" dark> Remover </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- <div>
			<canvas id="map"></canvas>
		</div> -->
	</v-container>
</template>
<style scoped>
.scroller {
	height: 500px;
	overflow-y: auto;
	/* border: 2px dashed rgba(132, 8, 8, 0.406); */
}

#map {
	position: fixed;
	top: 110px;
	right: 0;
	width: 80px;
	min-width: 80px;
	height: 100%;
	z-index: 100;
}

a {
	color: #f15a24;
}

.rowHovered {
	/* border-radius: 2px; */
	/* border: 1px solid #f15a24; */
	cursor: pointer;
	background-color: #f7f7f7;
}

.annotation {
	background-color: #f15a2405;
	/* border: 1px dashed #f15a24; */
}
.rowAnnotation:hover { 
	cursor: pointer;
	background-color: #f7f7f7;
}
.annotation ::v-deep img,
.comentario ::v-deep img {
	max-width: 100% !important;
}

.annotation ::v-deep iframe {
	height: 250px;
}

.annotation p {
	margin-bottom: 0px !important;
}
</style>
<script>
// import AvatarDpo from "../components/AvatarDpo.vue";
import { VueEditor } from "vue2-editor";
// import BtnCompartilhar from "../components/BtnCompartilahr.vue";
// import pagemap from "pagemap";
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

export default {
	name: "ConteudoNoticia",
	components: { VueEditor, DynamicScroller, DynamicScrollerItem },
	data() {
		return {
			idAnotacao: '',
			panel: [],
			isActive: false,
			files: [],
			annotation: { status: "private", texto: "" },
			delAnnotation: {},
			annotationVisible: "",
			anotacoes: [],
			showBusca: false,
			resultadoBusca: [],
			confirm: false,
			buscaModel: "",
			showNewAnnotation: false,
			conteudoSelected: {},
			conteudos: [],
			comentarios: {},
			avatar: {},
			comentario: "",
			idLei: 0,
			loading: false,
			loadingNewAnnotation: false,
			loadingDelete: false,
			lei: {},

			statusAnnotation: [
				{ text: "Público", value: "published" },
				{ text: "Grupo", value: "group" },
				{ text: "Privado", value: "private" },
				{ text: "Apenas Amigos", value: "friend" },
				{ text: "Arquivado", value: "archived" },
			],
			customToolbar: [
				[{ font: [] }, { size: [] }],
				["bold", "italic", "underline", "strike"],
				[{ color: [] }, { background: [] }],
				// [{ script: "super" }, { script: "sub" }],

				[
					{ list: "ordered" },
					{ list: "bullet" },
					{ indent: "-1" },
					{ indent: "+1" },
				],
				["direction", { align: [] }],
				["link", "image", "video"],
				["clean"],
			],
			customToolbar1: [
				[{ font: [] }, { size: [] }],
				["bold", "italic", "underline", "strike"],
				[{ color: [] }, { background: [] }],
				// [{ script: "super" }, { script: "sub" }],
				// [{ header: "1" }, { header: "2" }, "blockquote"],

				[
					{ list: "ordered" },
					{ list: "bullet" },
					{ indent: "-1" },
					{ indent: "+1" },
				],
				["direction", { align: [] }],
				["link", "image", "video"],

				["clean"],
			],
		};
	},
	async created() {
		this.idLei = this.$route.params.idLei;
		if (this.idLei) {
			this.loading = true;
			this.$http({ url: "items/leis/" + this.idLei }).then((data) => {
				this.lei = data.data.data;
			});
			this.$http({
				url:
					"items/conteudoleis/?limit=-1&sort=sort,id_reg&filter[id_lei][_eq]=" +
					this.idLei,
			}).then((data) => {
				// window.console.log(data.data.data)
				this.conteudos = data.data.data;
				this.reloadAnotacoes();
				// this.reloadComentarios();
				this.loading = false;
			});
			// this.$http({
			// 	url:
			// 		"items/comentario/?fields=*,user_created.avatar,user_created.first_name,user_created.last_name&filter[id_noticia][_eq]=" +
			// 		this.idLei,
			// }).then((data) => {
			// 	this.comentarios = data.data.data;
			// 	window.scrollTo(0, 0);
			// });
		}
	},
	mounted() {
		// pagemap(document.querySelector("#map"), {
		// 	viewport: null,
		// 	styles: {
		// 		p: "rgba(0,0,0,0.08)",
		// 		".annotation": "#F15A24",
		// 		"h2,h3,h4": "rgba(0,0,0,0.08)",
		// 	},
		// 	back: "rgba(0,0,0,0.02)",
		// 	view: "rgba(0,0,0,0.05)",
		// 	drag: "rgba(0,0,0,0.10)",
		// 	interval: 50,
		// });
	},
	computed: {
		user() {
			return this.$store.state.user
		},
		groups() {
			return this.$store.state.filteredGroups
		},
		editor() {
			return this.$refs.editor.quill;
		},
		intBreakPoint() {
			switch (this.$vuetify.breakpoint.name) {
				case "xs":
					return 0;
				case "sm":
					return 1;
				case "md":
					return 2;
				case "lg":
					return 3;
				case "xl":
					return 4;
				default:
					return 0;
			}
		},
	},
	methods: {
		newFile() {
			window.console.log(this.files)
			if (this.files) {
				if (confirm("Você deseja adicionar este arquivo a esta anotação? ")) {
					var formData = new FormData();
					formData.append("file", this.files);
					this.$http.post('/files', formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					}).then((response) => {
						let dt = response.data.data
						if (this.annotation.texto === undefined) { this.annotation.texto = "" }
						// window.console.log(this.annotation.texto)
						this.annotation.texto +=
							`<a href='https://api.mylegis.com.br/assets/${dt.id}?download' target='_blank' style='border:1px solid gray; padding:5px;'>${dt.filename_download}</a>`
						// window.console.log(dt)
						// this.$forceUpdate()

					})
				}
				this.files = null
			}
		},
		gotoRef(refName) {
			var position = refName - this.conteudos[0].id_reg;
			// window.console.log(refName)
			// // var top = document.getElementById(refName);
			// window.console.log({refName, position})
			// window.console.log(this.conteudos[0].id_reg)
			// window.console.log(this.$refs )

			// this.$refs.conteudos.$el.scrollTo({ top: position * 100, behavior: "smooth" })
			this.$refs.conteudos.scrollToItem(position)
			this.showBusca = false
			window.scrollTo({ top: 200, behavior: "smooth" });
		},
		clear() {
			this.editor.history.clear();
		},
		undo() {
			this.editor.history.undo();
		},
		redo() {
			this.editor.history.redo();
		},
		buscarLei() {
			this.$http.get(`items/conteudoleis/?search=` + this.buscaModel + `&filter[id_lei][_eq]=` +
				this.idLei).then(res => {
					this.resultadoBusca = res.data.data
					this.showBusca = true
				})
		},
		handleImageAdded(file, Editor, cursorLocation) {
			window.console.log(file);
			const formData = new FormData();
			formData.append("image", file);
			this.$http
				.post("/files", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then((response) => {
					window.console.log(response);
					let url = `https://api.mylegis.com.br/assets/${response.data.data.id}`;
					Editor.insertEmbed(cursorLocation, "image", url);
				})
				.catch((err) => {
					window.console.log(err);
				});
		},
		deleteAnnotation() {
			const id = this.delAnnotation.aId
			const cIndex = this.delAnnotation.cIndex
			const aIndex = this.delAnnotation.aIndex
			this.loadingDelete = true
			this.$http
				.patch(`/items/anotacoes/${id}`, {
					status: "archived",
				})
				.then(() => {
					//this.reloadAnotacoes();
					this.delAnnotation = {}
					this.confirm = false
					this.conteudos[cIndex].anotacoes.splice(aIndex, 1)
					this.loadingDelete = false
				});
		},
		editAnnotation(c, annotation) {
			this.conteudoSelected = { ...c };
			this.annotation = annotation;
			this.showNewAnnotation = true;
		},
		newAnnotation(c) {
			this.conteudoSelected = { ...c };
			this.showNewAnnotation = true;
		},
		saveNewAnnotation() {
			this.loadingNewAnnotation = true;
			let dt = {
				id_lei: this.idLei,
				id_reg: this.conteudoSelected.id_reg,
				status: this.annotation.status,
				id_grupo: this.annotation.id_grupo,
				texto: this.annotation.texto,
			};
			if (this.annotation.id === undefined) {
				this.$http
					.post("items/anotacoes", dt)
					.then((response) => {
						if (response.data.data.id != undefined) {
							// this.reloadAnotacoes();
							this.loadingNewAnnotation = false;
							this.showNewAnnotation = false;
							this.annotation = { status: "private", texto: "" },
								this.conteudoSelected = {};
							this.clear()

							let conteudo = this.conteudos.find(
								(el) => el.id_reg === dt.id_reg
							);
							if (conteudo.anotacoes)
								conteudo.anotacoes.push({ ...response.data.data, user_created: this.user });
							else conteudo.anotacoes = [{ ...response.data.data, user_created: this.user }];
						}
					})
					.catch(() => {
						this.loadingNewAnnotation = false;
					});
			} else {
				this.$http
					.patch("items/anotacoes/" + this.annotation.id, dt)
					.then((response) => {
						if (response.data.data.id != undefined) {
							// this.reloadAnotacoes();
							this.loadingNewAnnotation = false;
							this.showNewAnnotation = false;
							this.annotation = { status: "private" };
							this.conteudoSelected = {};
						}
					})
					.catch(() => {
						this.loadingNewAnnotation = false;
					});
			}
		},
		reloadAnotacoes() {
			this.$http({
				url: `items/anotacoes/?fields=*,user_created.avatar,user_created.first_name,user_created.last_name&filter[id_lei][_eq]=${this.idLei}&filter[user_created][_eq]=${this.$store.state.user.id}&filter[status][_neq]=archived`,
			}).then((data) => {
				this.anotacoes = data.data.data;
				this.anotacoes.forEach((anotacao) => {
					let conteudo = this.conteudos.find(
						(el) => el.id_reg === anotacao.id_reg
					);
					if (conteudo) {
						if (conteudo.anotacoes)
							conteudo.anotacoes.push(anotacao);
						else conteudo.anotacoes = [anotacao];
					}
				});
				// this.$forceUpdate();
				const searchParams = new URLSearchParams(window.location.search);
				if (searchParams.get('id')) {
					this.gotoRef(searchParams.get('id'))
				}
			});
		},
		reloadComentarios() {
			this.comentarios = []
			this.$http({
				url:
					"items/comentario_artigo/?fields=*,user_created.avatar,user_created.first_name,user_created.last_name&filter[id_lei][_eq]=" +
					this.idLei,
			}).then((data) => {
				this.comentarios = data.data.data;
			});
		},
		enviarComentario() {
			if (this.comentario === "") {
				window.alert("Por favor digite um comentário");
				return;
			}

			let comm = {
				id_lei: this.idLei,
				mensagem: this.comentario,
				status: "published",
			};

			this.$http
				.post("items/comentario_artigo", comm)
				.then((response) => {
					if (response.data.data.id != undefined) {
						this.reloadComentarios();
						this.comentario = "";
					}
				});
		},
		all() {
			this.panel = Array.from(Array(this.anotacoes.length).keys());
		},
		none() {
			this.panel = []
		},

	},
};
</script>
